// extracted by mini-css-extract-plugin
export default {"flyoverDuration":"350ms","opacityEndDuration":"300ms","tooltipClass":"Xkn4egT2cUj4GvjvB30h","flyoverClass":"quHaxHd9qf2jPZdS_XIt"};